import { render, staticRenderFns } from "./waiting-to-confirm.vue?vue&type=template&id=a76a644c&scoped=true&"
import script from "./waiting-to-confirm.vue?vue&type=script&lang=js&"
export * from "./waiting-to-confirm.vue?vue&type=script&lang=js&"
import style0 from "./waiting-to-confirm.vue?vue&type=style&index=0&id=a76a644c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76a644c",
  null
  
)

export default component.exports